"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarLineOnCommand = void 0;
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
/**
 * Turns on the visual appearance of measure lines.
 */
class BarLineOnCommand extends Command_1.Command {
    constructor() {
        super(CommandType_1.CommandType.BarLineOn);
    }
    static parse(_args) {
        return new BarLineOnCommand();
    }
}
exports.BarLineOnCommand = BarLineOnCommand;
